import { Handshake, Megaphone, Wallet, LifeBuoy, Globe2, FileCheck2 } from "lucide-react";
import { useSeo } from "../lib/seo";
import { PartnerLanding } from "../components/site/PartnerLanding";

const CFG = {
  key: "publishers", eyebrow: "Publishers & Traffic Partners", cta: "Become a Partner", defaultType: "Publisher",
  lines: ["Turn your traffic into", "lasting revenue."],
  intro: "Partner with AppTarget to access relevant affiliate campaigns, monetise your audience responsibly and grow with a team that supports you.",
  featuresEyebrow: "Partnership opportunities", featuresTitle: "Built for publishers who value quality.",
  featuresText: "Whether you run websites, apps, social channels or media buying operations, we can work together.",
  features: [
    { icon: Handshake, title: "Publisher partnerships", text: "Long-term relationships with clear terms, agreed traffic sources and shared goals." },
    { icon: Megaphone, title: "Affiliate campaign opportunities", text: "Access campaigns across finance, gaming, e-commerce, apps, utilities and lifestyle." },
    { icon: Wallet, title: "Traffic monetisation", text: "Earn on installs, actions, leads or sales generated by your audience." },
    { icon: Globe2, title: "Multiple traffic types", text: "In-app, display, native, search, social, email and content traffic, subject to campaign rules." },
    { icon: FileCheck2, title: "Clear campaign terms", text: "Payouts, KPIs and restrictions are shared up front for every campaign." },
    { icon: LifeBuoy, title: "Partnership support", text: "A dedicated contact to help with offers, creatives, tracking and optimisation." },
  ],
  modelsTitle: "Supported marketing models.",
  modelsText: "Work on the models that suit your traffic and audience.",
  models: [
    { code: "CPI", name: "Cost Per Install", text: "Earn for each qualifying app install you drive." },
    { code: "CPA", name: "Cost Per Action", text: "Earn when users complete defined actions such as sign-ups or deposits." },
    { code: "CPL", name: "Cost Per Lead", text: "Earn for qualified leads that meet campaign criteria." },
    { code: "CPS", name: "Cost Per Sale", text: "Earn a fixed payout or commission on completed sales." },
  ],
  stepsEyebrow: "Getting started", stepsTitle: "Start working with us in four steps.",
  steps: [
    ["Apply", "Share details about your traffic, audience and markets."],
    ["Review", "Our team reviews your application and traffic sources."],
    ["Access campaigns", "Receive campaigns that match your audience and model."],
    ["Grow together", "Optimise with our support and scale what works."],
  ],
  formEyebrow: "Publisher registration", formTitle: "Apply to become a partner.",
  formText: "Tell us about your traffic and our partnerships team will be in touch.",
  formPoints: ["Mention your main traffic sources", "Include your top geos and verticals", "Share any preferred payout models"],
};

export default function Publishers() {
  useSeo("Publishers & Traffic Partners", "Monetise your traffic with AppTarget. Affiliate campaign opportunities, CPI, CPA, CPL and CPS models, and dedicated partnership support.", "/publishers");
  return <PartnerLanding cfg={CFG} />;
}
